import { Input } from "formsy-react-components";

// FormsyControlledInput extends formsy-react Input and is controlled version of it
class FormsyControlledInput extends Input {
  constructor(props) {
    super(props);
    // changeValue method is overriden to avoid original behavior which changes the _value property of component state
    // This allows to set the value of the inout only through passing it as a prop (which can be validated).
    this.changeValue = event =>
      props.onChange(this.props.name, event.target.value);
  }
}

export default FormsyControlledInput;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/FormsyControlledInput.js